document.addEventListener('DOMContentLoaded', function () {
	const speedPerCharacter = 0.226;
	const classNames = ["marquee-left-to-right", "marquee-right-to-left"];

	classNames.forEach(className => {
		let marqueeElements = document.querySelectorAll("." + className);
		if (marqueeElements.length > 0) {
			marqueeElements.forEach(marqueeElement => {
				let contentLength = marqueeElement.textContent.length;
				let speed = contentLength * speedPerCharacter;
				marqueeElement.style.animationDuration = speed + "s";
			});
		}
	});
});
